import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import {calculateAmount, calculateReward} from "../../../../utils/calculate/Amount";
import {dateDDMMYY} from "../../../../utils/formatters/Date";
import InstitutionDropDown from "../../../../components/dropDown/institution";
import AccountDropDown from "../../../../components/dropDown/account";
import {numberWithComma, price, rate} from "../../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const TakeOrderAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Operación \ Posturas Administrativas \ Tomar Postura"/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button label="Cancelar"
                                    className="p-button-secondary"
                                    onClick={props.handleReturnButton}/>&nbsp;
                            <Button label="Guardar"
                                    disabled={props.isLoading}
                                    onClick={props.takeOrderAdmin}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <div className="p-grid">
                            <div className="p-col-4">
                                <SubtitleLabel header="Prestamista" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom>
                                    {
                                        props.orderTrade.nomCortoPtm !== '' &&
                                        props.orderTrade.nomCortoPtm
                                    }
                                    {
                                        props.orderTrade.nomCortoPtm === '' &&
                                        <InstitutionDropDown
                                            name="catInstitutionLender"
                                            filter="nombreCorto"
                                            save={props.saveDataOrderTrade}
                                            value={props.orderTrade.catInstitutionLender}
                                            loading={props.loading}
                                        />
                                    }
                                </Typography>
                            </div>
                            <div className="p-col-8">
                                <SubtitleLabel header="Prestatario" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom>
                                    {
                                        props.orderTrade.nomCortoPtt !== '' &&
                                        props.orderTrade.nomCortoPtt
                                    }
                                    {
                                        props.orderTrade.nomCortoPtt === '' &&
                                        <InstitutionDropDown
                                            name="catInstitutionBorrower"
                                            filter="nombreCorto"
                                            save={props.saveDataOrderTrade}
                                            value={props.orderTrade.catInstitutionBorrower}
                                            loading={props.loading}
                                        />
                                    }
                                </Typography>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Cuenta" isBold={true}/>
                                <Typography variant="subtitle2" gutterBottom>
                                    {
                                        props.orderTrade.nomCortoPtm !== '' &&
                                        props.orderTrade.cuenta
                                    }
                                    {
                                        props.orderTrade.nomCortoPtm === '' &&
                                        <AccountDropDown
                                            ref={props.accountDropDown}
                                            name="catAccount"
                                            filter="cuenta"
                                            save={props.saveDataOrderTrade}
                                            value={props.orderTrade.catAccount}
                                            sessionAccount={false}
                                            loading={props.loading}
                                        />
                                    }
                                </Typography>
                            </div>
                            <div className="p-col-8">
                                <SubtitleLabel header="Emisora" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.emision}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Títulos" isBold={true}/>
                                <SubtitleLabel header={numberWithComma(props.orderTrade.cantidad)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Tasa" isBold={true}/>
                                <SubtitleLabel header={rate(props.orderTrade.tasa)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Sobretasa" isBold={true}/>
                                <SubtitleLabel header={rate(props.orderTrade.sobreTasa)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Plazo" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.plazo}/>
                            </div>
                            <div className="p-col-8">
                                <SubtitleLabel header="Fecha Valor" isBold={true}/>
                                <SubtitleLabel header={dateDDMMYY(props.orderTrade.fecValor)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Precio" isBold={true}/>
                                <SubtitleLabel header={price(props.orderTrade.precio24Hrs)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Importe" isBold={true}/>
                                <SubtitleLabel
                                    header={calculateAmount(props.orderTrade.precio24Hrs, props.orderTrade.cantidad)}/>
                            </div>
                            <div className="p-col-4">
                                <SubtitleLabel header="Premio" isBold={true}/>
                                <SubtitleLabel header={calculateReward(
                                    props.orderTrade.cantidad,
                                    props.orderTrade.precio24Hrs,
                                    props.orderTrade.tasa,
                                    props.orderTrade.plazo,)}/>
                            </div>
                            <div className="p-col-12">
                                <SubtitleLabel header="Vigencia" isBold={true}/>
                                <SubtitleLabel header={props.orderTrade.vigencia === 0 ? 'Diaria' : 'Semanal'}/>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

TakeOrderAdmin.propTypes = {
    isLoading: PropTypes.bool.isRequired
};

export default TakeOrderAdmin;